import { loadStripe } from '@stripe/stripe-js';

// Load publishable key from environment variable
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.error('Stripe publishable key is missing! Check your .env file.');
}

export const stripePromise = loadStripe(stripePublishableKey);

export const STRIPE_CONFIG = {
  currency: 'usd',
  hireAmount: 9900, // $99.00 in cents
  description: 'WorkrMatch - Successful Hire Fee',
};